<template>
    <div>
        <el-dialog
            :visible.sync="dialogVisible"
            width="600px"
            :append-to-body="true"
            class="vipLv"
            :show-close="true"
        >
            <div slot="title">
                <p class="title-v">{{ $t("vip.level") }}</p>
            </div>
            <div>
                <div class="card">
                    <div class="header flexb">
                        <div class="tba1 center">{{ $t("vip.grade") }}</div>
                        <div class="tba2 center">{{ $t("vip.reached") }}</div>
                        <div class="tba3 center">{{ $t("vip.tips") }}</div>
                    </div>
                    <div class="centent borderl borderR">
                        <div
                            class="flexb borderB"
                            v-for="(item, i) of vipList"
                            :key="i"
                        >
                            <div class="tba1 center borderR">
                                {{ item.gradeName }}
                            </div>
                            <div class="tba2 center borderR">
                                {{ $t("vip.deposit") }}
                                {{ item.charge }},
                                {{ $t("vip.Valid") }}
                                {{ item.bet }}
                            </div>
                            <div class="tba3 center">
                                24h/{{ item.withdrawLimit
                                }}{{ $t("vip.Times") }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
export default {
    data() {
        return {
            vipList: [],
            dialogVisible: false,
        };
    },
    methods: {
        openAlert() {
            this.dialogVisible = true;
            this.getVip();
        },
        getVip() {
            this.$http.post(this.$api.getVipList, "").then((res) => {
                if (res.code == 0) {
                    this.vipList = res.data;
                }
            });
        },
    },
};
</script>

<style lang="scss" >
.vipLv {
    .el-dialog {
        min-height: 400px;
    }
    .el-dialog__body {
        padding: 0.4rem 0.7rem;
    }
    .el-dialog__headerbtn .el-dialog__close {
        font-size: 30px !important;
        color: #313131 !important;
    }
    .title-v {
        color: #3e444d;
        font-size: 0.35rem;
        font-weight: bold;
        text-align: center;
        margin-top: 0.2rem;
    }
    .card {
        .header {
            background: linear-gradient(0deg, #d9b26e, #f5d7a8);
            border-radius: 10px 10px 0px 0px;
            color: #553b0f;
            font-size: 0.14rem;
        }
        .centent {
            max-height: 4rem;
            overflow-y: auto;
        }
        .flexb {
            display: flex;
            align-items: center;
            line-height: 0.6rem;
            .tba1 {
                width: 25%;
                font-weight: bold;
            }
            .tba3 {
                width: 25%;
                font-weight: bold;
            }
            .tba2 {
                flex-grow: 2;
                font-weight: bold;
            }
        }
        .center {
            text-align: center;
        }
        .borderB {
            border-bottom: 1px solid #bfab9b;
        }
        .borderl {
            border-left: 1px solid #bfab9b;
        }
        .borderR {
            border-right: 1px solid #bfab9b;
        }
    }
}
</style>